module.exports = __webpack_public_path__ + "img/Samurai-Wolves-Logo-Template.jpg";